import Mustache from 'mustache';

global.search = (function() {
	var module = {},
		searchType = $('main .search').data('search-type'),
		$form = $('.filters form'),
		$page = $('.page.main'),
		$currentFilters = $('.currentFilters'),
		resultsTemplate = $('#resultsTemplate').html(),
		filtersTemplate = $('#currentFiltersTemplate').html(),
		listTemplate = $('#listTemplate').html(),
		locationTemplate = $('#locationTemplate').html(),
		ajaxTimer;

	//Parse mustache templates
	Mustache.parse(resultsTemplate);
	Mustache.parse(listTemplate);
	Mustache.parse(filtersTemplate);

	//Just so that you can get the currentfilters easily by typing carsearch.currentFilters() into console
	module.logFilters = function () {
		console.log(currentFilters);
	};

// Update URL, renderFilters, get and not reload when is mobile
	module.reRender = function() {
		if(windowWidth > mobileBreakpoint || searchPage){
			search.updateUrl();
			search.renderFilters();
			search.get();
		}
	}

	//Add new car, used car, stock car option to filter object
	//Filter carlist afterwards
	module.categories = function(carCategories){
		currentFilters.type = carCategories;

		if ( searchPage == userFilters ) {
			search.reRender();
		} else if ( windowWidth > mobileBreakpoint ) {
			var searchParemeters = search.createUrl(currentFilters);
			var resultsUrl = userFilters == 'car' ? '/fi/autot/autohaku/?' : '/fi/renkaat/rengashaku/?';
			window.location = resultsUrl + searchParemeters;
		}

		if( currentFilters.type.indexOf('used') !== -1 ) {
			$('.special-contracts').addClass('active');
		} else {
			$('.special-contracts').removeClass('active');
		}
	};

	//For Volvo Selekt and Autosalpa Contract checkboxes
	module.checkbox = function(key, val){
		currentFilters[key] = val;
		search.reRender();
	};

	//For min - max filters
	module.minMax = function(minKey, minVal, maxKey, maxVal) {
		currentFilters[minKey] = minVal;
		currentFilters[maxKey] = maxVal;
		search.reRender();
	};

	//For dropdown filters
	module.dropdown = function(key, val) {
		currentFilters[key] = val;
		search.reRender();
	};

	//Sort the cars
	module.sort = function(sort) {
		currentFilters.sortBy = sort;
		search.reRender();
	};


	//Here we choose what the action will be depending on what the user clicked
	module.filter = function(data, categoryName){
		//Define the filter set
		currentFilters = userFilters == 'car' ? window.currentCarFilters : window.currentTyreFilters;
		availableFilters = userFilters == 'car' ? window.carFilters : window.tyreFilters;

		//Define the selected filter
		var category = data.filterCategory,
			option = data.filterOption,
			name = data.filterName,
			extra = data.filterExtra,
			next = data.filterNext;
		//If not on the first filter page we will add the filter to our filters object and filter the carlist
		if ( $page.data('number') != 'one' ) {

			if (category == 'model' && userFilters == 'car') {
				if ( typeof currentFilters.model[extra] !== "undefined" ) {
					currentFilters.model[extra].push(option);
				} else {
					currentFilters.model[extra] = [option];
				}
			} else if ( $.inArray(option, currentFilters[category]) == -1 ) {
				currentFilters[category].push(option);
			}
			//Add filters to dom
			if ( searchPage ) {
				search.reRender();
			}
		}

		//If you are on the first page, aka category choosing the getFilters function will happen and nothing else
		//If we are not on the last page of the filter trail we will simply get the next set of filters.
		//If on the last page filter list will go on the first page. To allow the client to choose new filters.
		if ( windowWidth <= mobileBreakpoint ){
			if(next === 'reset' || extra){
				search.reset();
			} else {
				search.getFilters(data, categoryName);
			}
		} else if (next !== 'reset') {
			search.getFilters(data, categoryName);
		} else if ( searchPage == userFilters ) {
			search.reset();
		} else {
			var searchParemeters = search.createUrl(currentFilters);
			var resultsUrl = userFilters == 'car' ? '/fi/autot/autohaku/?' : '/fi/renkaat/rengashaku/?';
			window.location = resultsUrl + searchParemeters;
		}

	};

	//Get the next filters
	module.getFilters = function(data, categoryName) {

		var next = data.filterNext,
			category = data.filterCategory,
			option = data.filterOption,
			name = data.filterName,
			extra = data.filterExtra;

			var results = {
			  'options' : [],
			  'name' : categoryName
			};

			var filters = next == 'model' && userFilters == 'car' ? availableFilters['model'][option] : availableFilters[category];

			if (category === 'location') {

				results.options = {
                    autosalpa       : [],
					vaihtoautosalpa : []
				};

                for (let f in filters) {
					let locationFilter = {
						option   : filters[f],
						name     : (filters[f] === 'Hämeenlinna') ? filters[f] + ' Ruununmylly' : filters[f],
						category : category,
						extra    : '',
						next     : 'reset'
					};

					/*
					 * Separation on Autosalpa and Vaihtoautosalpa. I'm sorry.
					 */
					if (locationFilter.hasOwnProperty('name') && (locationFilter.name === 'Hamina' || locationFilter.name === 'Hämeenlinna Visamäki')) {
                        results.options.vaihtoautosalpa.push(locationFilter);
                    } else {
                        results.options.autosalpa.push(locationFilter);
					}
				}

                //Get filters and render them on to the next page.
                if (typeof locationTemplate === 'undefined') { locationTemplate = ''; }
                var rendered = Mustache.render(locationTemplate, results);

			} else {
				for (let f in filters) {
					var typeObj = typeof filters[f] === "object",
						newFilter = {
							'option' : typeObj ? filters[f].value : filters[f],
							'name' : typeObj ? filters[f].name : filters[f],
							'category' : typeObj ? filters[f].category : category,
							'extra' : option,
							'next' : category == 'manufacturer' && userFilters == 'car' && typeof option == "undefined" ? 'model' : 'reset'
						};


						if ( typeof newFilter.extra != "undefined" && newFilter.next == 'reset' ) {
							newFilter.category = 'model';
						}

					results.options.push(newFilter);
				}

                //Get filters and render them on to the next page.
								if (typeof listTemplate === 'undefined') { listTemplate = ''; }
                var rendered = Mustache.render(listTemplate, results);
            }

			//Define the next page and render results on that page
			$page = $page.next();
			$page.html(rendered);

			//Sometimes the scroll stays at the bottom when the navigation moves to the next page
			$('#navigation .content').animate({ scrollTop: 0 }, 1);


			//Add css class to form in order to know what part we want to show.
			$form.attr('class', $page.data('number') );

			//Add events to new filters
			$page.find('li:not(.back)').on('click', 'a', function(e) {
				e.preventDefault();
				search.filter( $(this).data(), $(this).text() );
			});
			$page.find('.back').click(function(e){
				e.preventDefault();
				search.reset('back');
			});

			$('.section-title .close').click(function(e){
				e.preventDefault();
				navigation.toggle('#navigation', $(this));
			});

	};

    var filtersVisible;
    function collapseFilters(){
        if($('.currentFilters .list .filter').length > 5) {
            $('.currentFilters .list .filter').slice(5).fadeOut();
            $('.currentFilters .list .filter').eq(4).after('<span href="#" class="show-filters">...</span>');
            filtersVisible = false;
        } else {
            $('.currentFilters .list .show-filters').remove();
        }
    }

	module.renderFilters = function () {
		currentFilters = userFilters == 'car' ? window.currentCarFilters : window.currentTyreFilters;
		availableFilters = userFilters == 'car' ? window.carFilters : window.tyreFilters;
		currentFilters.sortBy = $('select[name=sort]').val();

		if(currentFilters.manufacturer.indexOf('nissan') != -1 && currentFilters.manufacturer.indexOf('opel') == -1){
			$('#link_nissan').show();
			$('#link_opel').hide();
			$('#link_nissan_opel').hide();
		} else if(currentFilters.manufacturer.indexOf('opel') != -1 && currentFilters.manufacturer.indexOf('nissan') == -1){
			$('#link_opel').show();
			$('#link_nissan').hide();
			$('#link_nissan_opel').hide();
		} else if(currentFilters.manufacturer.indexOf('nissan') != -1 && currentFilters.manufacturer.indexOf('opel') != -1) {
			$('#link_nissan_opel').show();
			$('#link_nissan').hide();
			$('#link_opel').hide();
		} else {
			$('#link_nissan').hide();
			$('#link_opel').hide();
			$('#link_nissan_opel').hide();
		}

		if( currentFilters.type.indexOf('used') !== -1 ) {
			$('.special-contracts').addClass('active');
		} else {
			$('.special-contracts').removeClass('active');
		}

		var price = '', kilometrage = '', year = '', size = '', height = '', width = '';

		//Modify dom to show filters above car list
		//view object for mustache
		var view = {
			  filters: []
		};

		//Go through all the car filters and put them in the view object
		$.each(currentFilters, function(category, filters){
			//Get the models from the manufacturers array.
			if (typeof filters !== "object") {

				var add = false;

				var stringFilter = {
					'option' : filters,
					'category' : '',
					'index' : 1,
					'name' : ''
				};

				switch(category) {
					case 'priceMin':
						price += filters != 0 && filters != 'Min'  ? filters+' €' : '';
						break;
					case 'priceMax':
						price += filters != 0 && filters != 'Max' ? ' - '+filters+' €' : '';
						stringFilter.name = price;
						stringFilter.category = 'price';
						break;
					case 'yearMin':
						year += filters != 0 && filters != 'Min'  ? filters : '';
						break;
					case 'yearMax':
						year += filters != 0 && filters != 'Max' ? ' - '+filters : '';
						stringFilter.name = year;
						stringFilter.category = 'year';
						break;
					case 'kilometrageMin':
						kilometrage += filters != 0 && filters != 'Min'  ? filters+' km' : '';
						break;
					case 'kilometrageMax':
						kilometrage += filters != 0 && filters != 'Max' ? ' - '+filters+' km' : '';
						stringFilter.name = kilometrage;
						stringFilter.category = 'kilometrage';
						break;
					case 'size':
						size += filters != 0 && filters != 'Valitse' ? filters : '';
						stringFilter.name = size;
						stringFilter.category = 'size';
						break;
					case 'height':
						height += filters != 0 && filters != 'Valitse' ? filters : '';
						stringFilter.name = height;
						stringFilter.category = 'height';
						break;
					case 'width':
						width += filters != 0 && filters != 'Valitse' ? filters : '';
						stringFilter.name = width;
						stringFilter.category = 'width';
						break;
					case 'volvoselekt' :
						stringFilter.name = filters != 0 ? 'Volvo Selekt' : '';
						stringFilter.category = 'volvoselekt';
						if (filters != 0) {
							$('.volvo-selekt input').prop('checked', 1);
						}
						break;
					case 'autosalpa_contract' :
						stringFilter.name = filters != 0 ? 'Autosalpa Sopimus' : '';
						stringFilter.category = 'autosalpa_contract';
						if (filters != 0) {
							$('.autosalpa-contract input').prop('checked', 1);
						}
						break;
					case 'autosalpa_warranty' :
						stringFilter.name = filters != 0 ? 'Autosalpa Takuu' : '';
						stringFilter.category = 'autosalpa_warranty';
						if (filters != 0) {
							$('.autosalpa-warranty input').prop('checked', 1);
						}
					default :
				}

				if ( stringFilter.name != '' ) {
					view.filters.push(stringFilter);
				}

			} else if (category == 'model' && userFilters == 'car') {
				for(let f in filters) {
					var manufacturer = f;
					var models = filters[f];
					for (let m in models) {
						var model = {
						    'name' : manufacturer + ' ' + models[m],
						    'option' : models[m],
						    'category' : category,
						    'index' : manufacturer
						};
						view.filters.push(model);
					}
				}
			} else	{
				for(let f in filters) {
					var filterTypeObj = typeof filters[f] === "object", categoryIsArray = $.isArray(availableFilters[category]);

					var filterIndex = filters[f];

					//Category is not an array, filter is an object
					if ( !categoryIsArray && filterTypeObj && $.inArray(filters[f].name, availableFilters[category][f].name) !== -1  && category != 'vehicle_type') {
					 	var name = filters[f].name;
					}
					//Category is an array, filter is not an object
					else if ( categoryIsArray && !filterTypeObj && $.inArray(filters[f], availableFilters[category]) !== -1 && category != 'vehicle_type') {
					 	var name = filters[f];
					}
					//Category is not an array, filter is not an objcet
					else if ( !categoryIsArray && !filterTypeObj && filters[f] == availableFilters[category][filterIndex].value  && category != 'vehicle_type' ) {
						var name =	availableFilters[category][filterIndex].name;
					}
					//Category is an array, filter is an object
					else if ( categoryIsArray && filterTypeObj && $.inArray(filters[f].name, availableFilters[category][f].name) !== -1 || category == 'vehicle_type' ) {
					 	var name =	availableFilters[category][filterIndex].name;
					}
					//This happens only on type
					else {
						console.log(availableFilters[category]);
						var name = availableFilters[category][filterIndex].name;
					}

					var filter = {
						    'name' : name,
						    'option' : filterTypeObj ? filters[f].option : filters[f],
						    'category' : category,
						    'index' : f
					};

					view.filters.push(filter);

				}

			}
		});

		//Render on the page
		if (typeof filtersTemplate === 'undefined') { filtersTemplate = ''; }
		var rendered = Mustache.render(filtersTemplate, view);
		$currentFilters.find('.list').html(rendered);

        if( $('.currentFilters .list .filter').length > 5 && filtersVisible != true ) {
        	collapseFilters();
        }

        $('.currentFilters .list .show-filters').click(function() {
            if(filtersVisible == false || filtersVisible == 'undefined') {
                $('.currentFilters .list .filter').fadeIn();
                $(this).fadeOut();
                $(this).remove();
                filtersVisible = true;
            }
        });

		//Update carlisting new cars based on new filters
		//search.get();

		//Click event for deleting the filter
		$('.currentFilters a').click(function(e){
			search.removeFilter($(this).data('filter-index'), $(this).data('filter-category'), $(this).data('filter-option'));
		});

	};

	module.createUrl = function() {
		var serialize = function(obj, prefix) {
		  var str = [];
		  for(var p in obj) {
		    if ( obj.hasOwnProperty(p) ) {
		      var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
				if (v != "") {
				  str.push(typeof v == "object" ?
			        serialize(v, k) :
			        encodeURIComponent(k) + "=" + encodeURIComponent(v));
				}
		    }
		  }
		  return str.join("&");
		};
		return serialize(currentFilters);
	}

	module.updateUrl = function(action) {
		currentFilters.scrollTop = $('body').scrollTop();
		currentFilters.results = $('.search .results .car').length;
		window.history.pushState(currentFilters, "Search", '?'+ search.createUrl(currentFilters) );
		var currentState = window.history.state;
	};

	module.removeFilter = function(index, category, option) {

		var numbers = false;

		switch(category) {
			case 'price':
				currentFilters.priceMin = 0;
				currentFilters.priceMax = 0;
				numbers = true;
				$('.price select').prop('selectedIndex',0);
				break;
			case 'year':
				currentFilters.yearMin = 0;
				currentFilters.yearMax = 0;
				numbers = true;
				$('.year select').prop('selectedIndex',0);
				break;
			case 'kilometrage':
				currentFilters.kilometrageMin = 0;
				currentFilters.kilometrageMax = 0;
				numbers = true;
				$('.kilometrage select').prop('selectedIndex',0);
				break;
			case 'size':
				currentFilters.size = 0;
				numbers = true;
				$('.size select').prop('selectedIndex',0);
				break;
			case 'height':
				currentFilters.height = 0;
				numbers = true;
				$('.height select').prop('selectedIndex',0);
				break;
			case 'width':
				currentFilters.width = 0;
				numbers = true;
				$('.width select').prop('selectedIndex',0);
				break;
			case 'volvoselekt' :
				currentFilters.volvoselekt = 0;
				$('.volvo-selekt input').prop('checked', 0);
				break;
			case 'autosalpa_contract' :
				currentFilters.autosalpa_contract = 0;
				$('.autosalpa-contract input').prop('checked', 0);
				break;
			case 'autosalpa_warranty' :
				currentFilters.autosalpa_warranty = 0;
				$('.autosalpa-warranty input').prop('checked', 0);
			default :
		}

		if (!numbers) {
			if ( $.isArray( currentFilters[category] )  ) {

				var indx = parseInt(index);
				currentFilters[category].splice(indx, 1);

				if (category == 'type') {
					$('.car_category a').each(function(i, cat) {
						var $this = $(this);
						if ( $.inArray($this.data('category'), currentFilters.type) == -1 ) {
							$this.removeClass('active');
						}
					});
				}

				if ( category == 'manufacturer' && currentFilters.model && typeof currentFilters.model !== "undefined" ) {
					delete currentFilters['model'][option];
				}

			} else if ( category == 'model' ) {
				var models = currentFilters[category][index];
					let modelIndex = 0;
					for (var i = 0; i < models.length; i++) {
						if ( option == models[i] ) {
							modelIndex = i;
						}
					}
					currentFilters[category][index].splice(modelIndex, 1);
			} else {
				delete currentFilters[category][index];
			}
		}

		//Render current filters, renderFilters function will update car listing
		search.updateUrl();
		search.renderFilters();
		search.get();
	};

	//Get cars or tyres and render them on the page.
	module.get = function(lazyload){
		clearTimeout(ajaxTimer);
		ajaxTimer = setTimeout(function(){

			var $results = $('main .search .results'),
				url = $('main .search').data('action'),
				results;
				const offset = 25;
				const startOffset = lazyload ? offset : 0;
				currentFilters.offset = lazyload && currentFilters.offset ? currentFilters.offset + offset : startOffset;

					if ( resultsCount > 10 && lazyloadPosition < resultsCount ) {
						$('.loader').addClass('active');
					}

					$.ajax({
						url : url + '?stage-language=fi',
						data : currentFilters,
						success : function(data){
							results = data;
							resultsCount = results.count;
							$('span.search-results-amount').text( results.count );


							//append pixel if applicable
							$('.pixel').remove();
							if(typeof data.pixel !== "undefined" && data.pixel && data.pixel.length){
								$('.currentFilters .sort').after('<img class="pixel" src="'+data.pixel+'" width="1" height="1" />');
							}

							//append custom content
							$('.customContent').remove();
							if(typeof data.custom_content !== "undefined" && data.custom_content && data.custom_content.length){
								$('.currentFilters .sort').after('<div class="customContent grid-full"></div>');
								$.each(data.custom_content,function(i,el){									
									$('.customContent').append(el.text);
								})
							}

							//set h1-title, meta title and meta description
							var h1Arr = [], titleArr = [], pageDescription = []; /* = $('meta[name=description]').attr("content"); */


							if(window.currentCarFilters.manufacturer.length){
								h1Arr.push( window.carFilters.manufacturer[window.currentCarFilters.manufacturer[0]].name );
							}

							if(window.currentCarFilters.type.length){
								h1Arr.push(window.carFilters.type[window.currentCarFilters.type[0]].name );

							}
							if(window.currentCarFilters.location.length){
								h1Arr.push( window.currentCarFilters.location[0] );

							}
							if(window.currentCarFilters.megasearch.length){
								h1Arr.push( window.currentCarFilters.megasearch[0] );

							}

							var h1Str = h1Arr.join(' ');

							if($('body').hasClass('car-search')){
								$('.search > h1:first-child').text("Tulokset: "+h1Str);
								$('meta[name=description]').attr("content",h1Str);
								document.title = h1Str;
							}
						},
						complete : function(){
							if (typeof resultsTemplate === 'undefined') { resultsTemplate = ''; }
							var rendered = Mustache.render(resultsTemplate, results);

							if (lazyload) {
								$results.append(rendered);
							} else {
								$results.html(rendered);
							}

							$('.loader').removeClass('active');
							search.updateUrl();
							if($('.search .results .car').length >= parseInt(resultsCount)){ $('.search .show-more').addClass('disabled'); }
							else { $('.search .show-more').removeClass('disabled'); }
							$('.car > a').on('click', function(e) {
								search.updateUrl('scrollTop');
							});
						},
						error : function(e){
							console.error(e);
						}
					});

		}, 50);
	};


	//Reset search to first page
	module.reset = function(action) {
		
		if ( action == 'back' && $('.car-filters form').hasClass('three') ) {

			$('.car-filters form').removeClass('three');
			$('.car-filters form').addClass('two');
			$page = $('.page.main').next();

		} 	else {

			$('.filters form').attr('class', '');
			$('.filters .page:not(.main)').empty();
			$page = $('.page.main');

			//This happens on the tablet version
			if ( windowWidth >= 640 && windowWidth <= 1280 )  {
				navigation.toggle('#navigation', $('li.navigation a.active'));
			}
		}
	};

	module.init = function(){
		currentFilters = $('body').hasClass('car-search') ? window.currentCarFilters : window.currentTyreFilters;
		availableFilters = $('body').hasClass('car-search') ? window.carFilters : window.tyreFilters;

		if ( typeof searchPage !== "undefined" && searchPage && searchPage !== '' ) {

			search.renderFilters();

			if (userFilters == 'tyre') {

				$('.filters.tyre-filters').addClass('active');
				$navigations.addClass('sub');
				$('.navigation-last-level').hide();
				$navigations.addClass('show-tyres');

			} else if (userFilters == 'car') {

				$('.navigation-sub-level').hide();
				$('.navigation-last-level').hide();
				$('.filters.car-filters').addClass('active');
				$navigations.addClass('sub');

			}

			$('.search .show-more').click(function(e){
				var eventPosition = parseInt( $('footer').offset().top ) - 450;
				var scrollBottom = parseInt($(window).scrollTop()) + parseInt(windowHeight);
				if (scrollBottom > eventPosition && !$(this).hasClass('disabled')) {
					search.get(true);
				}
			});
		} 
		$('.page.main li').on('click', 'a', function(e) {
			e.preventDefault();
			search.filter( $(this).data(), $(this).text());
		});


		$('.car_category').on('click', 'a', function(e) {
			e.preventDefault();
			var carCategories = [];
			$(this).toggleClass('active');

			$('.car_category a.active').each(function(){
				carCategories.push( $(this).data('category') );
			});

			search.categories(carCategories);
		});


		$('.car > a').on('click', function(e) {
			search.updateUrl('scrollTop');
		});

		if(window.history.state){ $('body').scrollTop(window.history.state.scrollTop);console.log('check!'); }


		//Car search range filters
		$('.filters .range.year select').change(function(){
			var min = $('select[name=yearMin]'),
				max = $('select[name=yearMax]');
				search.minMax(min.attr('name'), min.val(), max.attr('name'), max.val());
		});
		$('.filters .range.kilometrage select').change(function(){
			var min = $('select[name=kilometrageMin]'),
				max = $('select[name=kilometrageMax]');
				search.minMax(min.attr('name'), min.val(), max.attr('name'), max.val());
		});

		//Tyre search range filters
		$('.filters .range.width select').change(function(){
			/*var min = $('select[name=widthMin]'),
				max = $('select[name=widthMax]');
				search.minMax(min.attr('name'), min.val(), max.attr('name'), max.val());*/
			var dropdown = $('select[name=width]');
			search.dropdown(dropdown.attr('name'),dropdown.val());
		});
		$('.filters .range.height select').change(function(){
			/*var min = $('select[name=heightMin]'),
				max = $('select[name=heightMax]');
				search.minMax(min.attr('name'), min.val(), max.attr('name'), max.val());*/
			var dropdown = $('select[name=height]');
			search.dropdown(dropdown.attr('name'),dropdown.val());
		});
		$('.filters .range.size select').change(function(){
			/*var min = $('select[name=sizeMin]'),
				max = $('select[name=sizeMax]');
				search.minMax(min.attr('name'), min.val(), max.attr('name'), max.val());*/
			var dropdown = $('select[name=size]');
			search.dropdown(dropdown.attr('name'),dropdown.val());
		});

		//For both
		$('.filters.car-filters .range.price select').change( function(){
			var min = $('.car-filters select[name=priceMin]'),
				max = $('.car-filters select[name=priceMax]');
				search.minMax(min.attr('name'), min.val(), max.attr('name'), max.val());
		});

		$('.filters.tyre-filters .range.price select').change( function(){
			var min = $('.tyre-filters select[name=priceMin]'),
				max = $('.tyre-filters select[name=priceMax]');
				search.minMax(min.attr('name'), min.val(), max.attr('name'), max.val());
		});


		$('select[name=sort]').change(function(){
			currentFilters.results = 10;
			search.sort( $(this).val() );
		});

		$('.search-cars').click(function(e){
			e.preventDefault();
			if ( searchPage == userFilters ) {
				search.reRender();
				search.reset('search');
				if (windowWidth <= 640) {
					$menuSections.removeClass('active');
					$sectionSelectionItem.find('.active').removeClass('active');
					$('#navigation').removeClass('active');
					document.documentElement.style.overflow = 'initial';
				}
			} else {
				var searchParemeters = search.createUrl(currentFilters);
				var resultsUrl = userFilters == 'car' ? '/fi/autot/autohaku/?' : '/fi/renkaat/rengashaku/?';
				window.location = resultsUrl + searchParemeters;
			}

		});

		$('.search-tyres').click(function(e){
			e.preventDefault();

			if ( searchPage == userFilters ) {
				search.reset('search');
			} else {
				var searchParemeters = search.createUrl(currentFilters);
				var resultsUrl = userFilters == 'car' ? '/fi/autot/autohaku/?' : '/fi/renkaat/rengashaku/?';
				window.location = resultsUrl + searchParemeters;
			}

		});

		$('.addFilters').click(function(e){
			navigation.toggle('#navigation', $('li.navigation a'));
		});

		$('.section-title .close').click(function(e){
				e.preventDefault();
				navigation.toggle('#navigation', $(this));
		});

		$('.volvo-selekt input').change(function(){
			if ( $('.volvo-selekt input:checked').length > 0 ) {
				search.checkbox($(this).attr('name'), $(this).val());
			} else {
				search.removeFilter(1, 'volvoselekt', 1);
			}
		});

		$('.autosalpa-contract input').change(function(){
			if ( $('.autosalpa-contract input:checked').length > 0 ) {
				search.checkbox($(this).attr('name'), $(this).val());
			} else {
				search.removeFilter(1, 'autosalpa_contract', 1);
			}
		});

		$('.autosalpa-warranty input').change(function(){
			if ( $('.autosalpa-warranty input:checked').length > 0 ) {
				search.checkbox($(this).attr('name'), $(this).val());
			} else {
				search.removeFilter(1, 'autosalpa_warranty', 1);
			}
		});

	}

	return module;
})();